import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import { action } from "satcheljs";

export interface ON_LIST_VIEW_TYPE_OPTION_SAVEDActionMessage {
    newListViewType: ReactListViewType;
}
export const onListViewTypeOptionSaved: (newListViewType: ReactListViewType) => ON_LIST_VIEW_TYPE_OPTION_SAVEDActionMessage = action("ON_LIST_VIEW_TYPE_OPTION_SAVED", (newListViewType: ReactListViewType): ON_LIST_VIEW_TYPE_OPTION_SAVEDActionMessage => {
    return {
        newListViewType,
    };
});
